import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

function cta() {

	gsap.registerPlugin(ScrollTrigger);

	const ctaSections = document.querySelectorAll('.ctaSection');

	ctaSections.forEach(cta => {
		if (cta.closest('.wp-block-group')) {
			cta.classList.add('inContainer');
		}
	});

	document.querySelectorAll('.ctaimgContainer').forEach(imageContainer => {
		gsap.fromTo(imageContainer,
			{ xPercent: 100, opacity: 0 },
			{
				xPercent: 0,
				opacity: 1,
				duration: 1,
				ease: "power2.out",
				scrollTrigger: {
					trigger: imageContainer,
					start: "top 90%",
					end: "top 30%",
					scrub: true,
				}
			}
		);
	});
}

export {cta};